import { Spinner } from '@/components/shared';
import React, { Suspense, lazy, useEffect, useState, type ComponentType, type FC } from 'react';
import { IViewResolverComponentProps } from 'Components/view-resolver/view-resolver.interface';

// @ts-ignore: federated module

const SkinDiagnosticPage: FC<IViewResolverComponentProps> = () => {
  const [SkinDiagnostic, setSkinDiagnostic] = useState<ComponentType<any> | null>(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      setSkinDiagnostic(lazy(() => import('beautyFrontendPlp/SkinDiagnostic')));
    }
  }, []);
  return (
    <>
      <Suspense fallback={<Spinner />}>{SkinDiagnostic ? <SkinDiagnostic /> : null}</Suspense>
    </>
  );
};

export default SkinDiagnosticPage;
